import type { ListData } from '../../../types';
import BottomDrawer from './BottomDrawer';
import ExternalLinkIcon from './icons/ExternalLinkIcon';

interface ChaptersDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  items: ListData[];
  currentPosition: number;
  onSelectChapter: (index: number) => void;
}

const ChaptersDrawer = ({
  isOpen,
  onClose,
  items,
  currentPosition,
  onSelectChapter,
}: ChaptersDrawerProps) => {
  return (
    <BottomDrawer isOpen={isOpen} onClose={onClose}>
      <div
        style={{
          maxHeight: '60vh',
          overflowY: 'auto',
          margin: '0 -24px',
          padding: '0 24px',
        }}
      >
        {items.map((item, index) => {
          const isActive = index === currentPosition;
          return (
            <div
              key={item.id}
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '14px 0',
                borderBottom:
                  index < items.length - 1 ? '1px solid var(--border)' : 'none',
              }}
            >
              {/* Active dot indicator */}
              <div
                style={{
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  background: isActive ? 'var(--teal)' : 'transparent',
                  flexShrink: 0,
                }}
              />
              <button
                onClick={() => {
                  onSelectChapter(index);
                  onClose();
                }}
                style={{
                  flex: 1,
                  fontSize: '1rem',
                  color: isActive ? 'var(--teal)' : 'var(--primary)',
                  fontWeight: isActive ? 600 : 400,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  textAlign: 'left',
                  textDecoration: 'underline',
                  textUnderlineOffset: '3px',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: 0,
                }}
              >
                {item.title}
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(`/id/${item.id}`, '_blank');
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '4px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'var(--secondary)',
                  flexShrink: 0,
                }}
                title="Open in new tab"
              >
                <ExternalLinkIcon size={18} />
              </button>
            </div>
          );
        })}
      </div>
    </BottomDrawer>
  );
};

export default ChaptersDrawer;
